<template>
    <v-flex xs12 class="group_banner">
        <v-layout row wrap>
            <v-flex sm8>
                <Breadcrumb></Breadcrumb>
                <v-flex class="community_title">
                    <v-flex class="community_title__name">{{'YPO Speaker Resource Directory Administration'}}</v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>

    import Breadcrumb from "../Layout/Breadcrumb";

    export default {
        name: 'SpeakerBanner',
        components: {

            Breadcrumb,
        },
        created() {},

        methods: {},

    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .group_banner {
        background: url(../../assets/generic-banner.png);
        position: relative;
        min-height: 150px;
        background-size: cover;
        background-position: center;
        margin-top: 55px;

        &:before {
            content: '';
            background: rgba($ypo_blue, 0.5);
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .awards_block {
            position: absolute;
            right: 29px;
            top: 20px;
            z-index: 1;
            text-align: right;
            font-size: 12px;
            color: $white;
            font-family: 'Raleway', sans-serif;

            span {
                float: left;
                padding-top: 12px;
                font-size: 10px;
            }

            strong {
                display: block;
                font-size: 14px;
                font-weight: 500;
            }

            img {
                max-width: 28px;
                float: right;
                margin-left: 3px;
            }
        }

    }
</style>
